export default "__VITE_ASSET__i0Lj4kap__"